import { createReducer, on } from '@ngrx/store';
import * as fromTournamentActions from '../actions/tournament.action';
export const featureKey = 'tournament';

export interface State {
    seasons: {
        data: Array<any>,
        isLoaded: Boolean
    };
    leagues: {
        data: Array<any>,
        isLoaded: Boolean
    };
    leagueDetails: any;
    leagueGames: {
        data: Array<any>,
        isLoaded: Boolean
    };
    leaguePlayers: {
        data: Array<any>,
        league: any,
        isLoaded: Boolean
    };
}

export const initialState: State = {
    seasons: {
        data: [],
        isLoaded: false
    },
    leagues: {
        data: [],
        isLoaded: false
    },
    leagueDetails: null,
    leagueGames: {
        data: [],
        isLoaded: false
    },
    leaguePlayers: {
        data: [],
        league: null,
        isLoaded: false
    },
}

export const reducer = createReducer(
    initialState,
    on(fromTournamentActions.getSeasonsSuccess, (state: State, props: any) => ({
        ...state,
        seasons: { data: props.data, isLoaded: true },
    })),
    on(fromTournamentActions.getLeaguesSuccess, (state: State, props: any) => ({
        ...state,
        leagues: { data: props.data, isLoaded: true },
    })),
    on(fromTournamentActions.getLeagueDetailsSuccess, (state: State, props: any) => ({
        ...state,
        leagueDetails: props.data,
    })),
    on(fromTournamentActions.getLeagueGamesSuccess, (state: State, props: any) => ({
        ...state,
        leagueGames:{ data: props.data, isLoaded: true },
    })),
    on(fromTournamentActions.getLeaguePlayersSuccess, (state: State, props: any) => ({
        ...state,
        leaguePlayers: { data: props.data, league: props.league, isLoaded: true },
    })),
    // on(fromAuthActions.autoLogout, (state: State, props) => initialState),
);